var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/shield-tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M98.8803 22.465L69.5469 11.4783C66.5069 10.3583 61.5469 10.3583 58.5069 11.4783L29.1736 22.465C23.5203 24.5983 18.9336 31.2116 18.9336 37.2383V80.4383C18.9336 84.7583 21.7603 90.465 25.2269 93.025L54.5603 114.945C59.7336 118.838 68.2136 118.838 73.3869 114.945L102.72 93.025C106.187 90.4116 109.014 84.7583 109.014 80.4383V37.2383C109.067 31.2116 104.48 24.5983 98.8803 22.465ZM82.5603 52.3316L59.6269 75.265C58.8269 76.065 57.8136 76.4383 56.8003 76.4383C55.7869 76.4383 54.7736 76.065 53.9736 75.265L45.4403 66.625C43.8936 65.0783 43.8936 62.5183 45.4403 60.9716C46.9869 59.425 49.5469 59.425 51.0936 60.9716L56.8536 66.7316L76.9603 46.625C78.5069 45.0783 81.0669 45.0783 82.6136 46.625C84.1603 48.1716 84.1603 50.785 82.5603 52.3316Z",
    fill: "#EFEFEF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldTick);
export default __webpack_public_path__ + "static/media/shield-tick.9b252ee4e5b91253a73b33f41c6d33ff.svg";
export { ForwardRef as ReactComponent };